import styled from '@emotion/styled';
import svg from '../../public/images/cart.svg';

const Icon = styled(svg)``;

Icon.whyDidYouRender = true;

export default Icon;
